"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contents = exports.PageButton = exports.ArrowRightIcon = exports.ArrowLeftIcon = exports.ArrowRightContainer = exports.ArrowLeftContainer = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const svg_components_1 = require("../../../assets/svg-components");
exports.Container = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${props => (props.isSmall ? props.theme.spacing.s5 : 0)}px;

  > button {
    cursor: pointer;
    height: 100%;
    background: none;
    border: none;
    padding: 0;
  }

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    justify-content: space-between;
    width: 100%;
  }
`;
exports.ArrowLeftContainer = styled_components_1.default.button `
  ${props => props.disabled && `opacity: 0.2;`}
  margin-right: ${props => (props.isSmall ? props.theme.spacing.s1 : props.theme.spacing.s5)}px;
  width: ${props => props.theme.constants.mobileMenu.iconWrapper}px;
  height: ${props => props.theme.constants.mobileMenu.iconWrapper}px;
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    margin-right: ${props => (props.isSmall ? props.theme.spacing.s1 : props.theme.spacing.s2)}px;
  }
`;
exports.ArrowRightContainer = styled_components_1.default.button `
  ${props => props.disabled && `opacity: 0.2;`}
  margin-left: ${props => (props.isSmall ? props.theme.spacing.s1 : props.theme.spacing.s5)}px;
  width: ${props => props.theme.constants.mobileMenu.iconWrapper}px;
  height: ${props => props.theme.constants.mobileMenu.iconWrapper}px;
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    margin-left: ${props => (props.isSmall ? props.theme.spacing.s1 : props.theme.spacing.s2)}px;
  }
`;
exports.ArrowLeftIcon = (0, styled_components_1.default)(svg_components_1.ArrowIcon) `
  transform: rotate(90deg);
`;
exports.ArrowRightIcon = (0, styled_components_1.default)(svg_components_1.ArrowIcon) `
  transform: rotate(270deg);
`;
exports.PageButton = styled_components_1.default.button `
  background: none;
  border: none;
  ${props => !props.dots && `cursor: pointer;`}
  ${props => props.dots && `user-select: none;`}
  font-size: ${props => props.theme.typography.size.s3}px;
  font-weight: ${props => props.theme.typography.weight.medium};
  color: ${props => props.theme.palette.LIGHT_BLACK};
  ${props => props.selected && `outline: 1px solid ${props.theme.palette.LIGHT_BLACK};`}
  width: ${props => props.theme.constants.mobileMenu.iconWrapper}px;
  height: ${props => props.theme.constants.mobileMenu.iconWrapper}px;
  display: inline-flex;
  justify-content: center;
  align-items: center;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    width: ${props => props.theme.constants.blockWidth.s6}px;
    height: ${props => props.theme.constants.blockWidth.s6}px;
  }

  :not(:last-child) {
    margin-right: ${props => (props.isSmall ? props.theme.spacing.s1 : props.theme.spacing.s4)}px;
    @media (max-width: ${props => props.theme.breakpoints.md}px) {
      margin-right: ${props => (props.isSmall ? props.theme.spacing.s1 : props.theme.spacing.s3)}px;
    }
    @media (max-width: ${props => props.theme.breakpoints.sm}px) {
      margin: ${props => (props.isSmall ? props.theme.spacing.s1 : 0)}px;
    }
  }

  :focus {
    outline: 2px solid ${props => props.theme.palette.ORANGE_100};
  }

  :hover {
    color: ${props => props.theme.palette.BLUE_100};
  }
`;
exports.Contents = styled_components_1.default.div `
  display: contents;
`;
exports.default = {
    Container: exports.Container,
    ArrowLeftIcon: exports.ArrowLeftIcon,
    ArrowRightIcon: exports.ArrowRightIcon,
    PageButton: exports.PageButton,
    ArrowLeftContainer: exports.ArrowLeftContainer,
    ArrowRightContainer: exports.ArrowRightContainer,
    Contents: exports.Contents
};
